import type { CurrencyCode } from '@/helpers/currency';
import { DEMO_CURRENCY } from '@/helpers/variables';
import type { GamesCurrenciesResolver } from './types';

const walletsCurrenciesResolver: GamesCurrenciesResolver = {
  isApplicable: ({ wallets }) => wallets.length > 0,
  resolve: ({ wallets }) =>
    wallets
      .map(({ currency }) => currency as CurrencyCode)
      .sort((a, b) => a.localeCompare(b)),
};

export const demoCurrencyResolver: GamesCurrenciesResolver = {
  isApplicable: () => true,
  resolve: () => [DEMO_CURRENCY],
};

export const GAMES_CURRENCIES_RESOLVERS: GamesCurrenciesResolver[] = [
  walletsCurrenciesResolver,
];
